exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".contract-checkout-page section:first-child{padding-top:25px}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./src/components/checkout/Checkout/ContractCheckout.scss
 ** module id = 1223
 ** module chunks = 0
 **/